module.exports = new __parcel__URL__("map-light.f900f6af.svg").toString();